import { ThunkAction } from "redux-thunk";
import { IExtra, RootAction, RootState } from "../types";

import {
  fetchProfiles as fetchProfilesAction,
  updateProfileProgress,
} from "../actions";
import { IProfileUpdate } from "src/api/APIClient";

export function updateProfile(
  update: IProfileUpdate
): ThunkAction<void, RootState, IExtra, RootAction> {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(updateProfileProgress.request(update));

      const profile = await api.updateProfile(update);

      dispatch(updateProfileProgress.success(profile));
    } catch (err) {
      dispatch(updateProfileProgress.failure(err));
    }
  };
}

export function fetchProfiles(): ThunkAction<
  void,
  RootState,
  IExtra,
  RootAction
> {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(fetchProfilesAction.request());

      const profiles = await api.listProfiles();

      dispatch(fetchProfilesAction.success(profiles));
    } catch (err) {
      dispatch(fetchProfilesAction.failure(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/thunks/profileThunks.ts